import "./MeterBar.scss";

import React from "react";

import { useTheme } from "../../state/ThemeProvider";

// Base component for Usage Meter Bar components (ie: Response Usage Meter, Template Usage Meter, etc)

type MeterBarProps = {
  progressPercentage: number;
  warningPercentage?: number;
};

export const MeterBar: React.FC<MeterBarProps> = ({ progressPercentage, warningPercentage }) => {
  const theme = useTheme();
  let statusClass = "default";
  if (progressPercentage >= 100) {
    statusClass = "danger";
  } else if (warningPercentage && progressPercentage >= warningPercentage) {
    statusClass = "warning";
  }

  return (
    <div className={`MeterBar__container MeterBar__container-${theme.themeName}`}>
      <span
        className={`MeterBar__used MeterBar__used-${statusClass}`}
        style={{ width: `${progressPercentage}%` }}
      ></span>
    </div>
  );
};
